import React from "react";
import RegisterWithPhoneView from "./RegisterWithPhoneView";

export default function RegisterWithPhoneController(props){

    return(
        <RegisterWithPhoneView />
    )
}